import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=33cab6f2&scoped=true&"
import script from "./Shipping.vue?vue&type=script&lang=js&"
export * from "./Shipping.vue?vue&type=script&lang=js&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=33cab6f2&prod&scoped=true&lang=scss&"
import style1 from "./Shipping.vue?vue&type=style&index=1&id=33cab6f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cab6f2",
  null
  
)

export default component.exports